import styled from 'styled-components'
import React, { useEffect } from 'react'
import logoImg from '../assets/logo2.png'
import { useSelector, useDispatch } from 'react-redux'
import { getSelectedCategory } from '../utils/cookie'
import { useNavigate } from 'react-router-dom'
import { setCookie } from '../utils/cookie'

function HeaderPc() {
  const categoryList = useSelector((state) => {
    return state.category.category
  })
  const navigate = useNavigate()
  return (
    <MainContainer>
      <Logo src={logoImg} 
      
        onClick={() => {
          navigate('/')
        }}
      
      />
      <BtnsContainer>
        {categoryList?.map((category) => (
          <Btn
            key={category.caSeq}
            selected={getSelectedCategory() == category.caSeq}
            onClick={() => {
              setCookie('selectedCategory', category.caSeq);
              navigate(`/category/${category.caSeq}`);

              
            }}
          >
            {category.caName}
          </Btn>
        ))}
      </BtnsContainer>
    </MainContainer>
  )
}

export default HeaderPc

const MainContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 82px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  background: #fff;
  z-index: 1000;
`
const Logo = styled.img`
  width: auto;
  height: 26px;
  margin-left: 46px;
  margin-bottom: 20px;
`
const BtnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 11.8px;
  margin-right: 46px;
  margin-bottom: 20px;
  overflow: visible !important;
`
const FlooringContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 3px;
  overflow: visible !important;
`
const Btn = styled.p`
  font-family: GmarketSans;
  font-weight: bold;
  font-size: 14px;
  line-height: 0.8;
  overflow: visible !important;
  /* color: \${(props) => (props.selected ? '#000' : '#bcbcbc')}; */
  color: #000;
  cursor: pointer;
`
const N = styled.p`
  font-weight: bold;
  font-size: 9px;
  line-height: 0.3;
  color: #ed6c01;
  overflow: visible !important;
`
